import { render, staticRenderFns } from "./HomeTestimonials.vue?vue&type=template&id=0822d47c&scoped=true&"
import script from "./HomeTestimonials.vue?vue&type=script&lang=js&"
export * from "./HomeTestimonials.vue?vue&type=script&lang=js&"
import style0 from "./HomeTestimonials.vue?vue&type=style&index=0&id=0822d47c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0822d47c",
  null
  
)

export default component.exports